<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container" v-if="role === 'admin'">
      <div class="breadCrumbsContainer" style="display: flex;">
        アクセスログ
      </div>

      <!-- <div class="row" style="margin-bottom: 0px;">
        <p class="inputTitle condition" style="min-width: 140px; max-width: 140px">期間指定</p>
        <div style="display: flex;">　
          <v-date-picker @input="picker(searchRange)" v-model="searchRange" is-range :formats="serchFormats" style="display: flex;">
            <template v-slot="{ inputValue, inputEvents }">
              <div class="row" style="margin-bottom: 0px;">
                <input
                :value="inputValue.start + ' ～ ' + inputValue.end"
                v-on="inputEvents.start"
                class="text small"
                style="margin: auto 0; width: 300px;"
                id='range'
                disabled
                >
              </div>
            </template>
          </v-date-picker>
        </div>
      </div> -->

      <div class="row" style="margin-bottom: 0px;">
        <p class="inputTitle condition" style="min-width: 140px; max-width: 140px">ユーザーID</p>
        <multiselect
          v-model="userIdCondition"
          :options="userIdOptions"
          :multiple="true"
          :taggable="true"
          label="name"
          track-by="code"
          placeholder="検索したいユーザIDを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          @tag="addUserIdTag"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
        <p class="inputTitle condition" style="min-width: 140px; max-width: 140px">リクエストパス</p>
        <multiselect
          v-model="pathCondition"
          :options="pathOptions"
          :multiple="true"
          :taggable="true"
          label="name"
          track-by="code"
          placeholder="検索したいリクエストパスを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          @tag="addPathTag"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
      </div>
      <div class="row" style="margin-bottom: 0px;">
        <p class="inputTitle condition" style="min-width: 140px; max-width: 140px">リクエスト種別</p>
        <multiselect
          v-model="methodCondition"
          :options="methodOptions"
          :close-on-select="false"
          :multiple="true"
          :taggable="true"
          placeholder="すべて"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
        <p class="inputTitle condition" style="min-width: 140px; max-width: 140px">IPアドレス</p>
        <multiselect
          v-model="ipCondition"
          :options="ipOptions"
          :multiple="true"
          :taggable="true"
          label="name"
          track-by="code"
          placeholder="検索したいIPアドレスを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          @tag="addIpTag"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
      </div>
      <div class="searchBtn" @click="search()">検索</div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- ソートローディング -->
      <!-- <div v-if="lodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div> -->
      <!-- 現在表示件数 / 検索結果最大件数 -->
      <div style="text-align:right" v-if="!getLodingFlg && !getErrorFlg">
        <div v-if="limit * currentPage <= maxCount">
          {{(limit * currentPage) - (limit - 1)}} - {{limit * currentPage}} / {{maxCount}} 件
        </div>
        <div v-else>
          {{(limit * currentPage) - (limit - 1)}} - {{maxCount}} / {{maxCount}} 件
        </div>
      </div>
      <!-- ページネーション -->
      <div class="vgt-wrap__footer vgt-clearfix" v-if="!getLodingFlg && !getErrorFlg">
        <div class="footer__navigation vgt-pull-right">
          <div class="footer__navigation__page-info">
            <label for="vgt-page-input1" class="page-info__label">
              <span>ページ</span>
              <input id="vgt-page-input1" aria-controls="vgb-table" type="text"
               v-model="inputPage" @keypress.enter="paginationInput" @blur="paginationBlue"
               class="footer__navigation__page-info__current-entry">
               <span>/ {{maxPage}}</span>
             </label>
          </div>
          <button type="button" aria-controls="vgt-table"
            class="footer__navigation__page-btn" @click="pagination('back')"
            v-bind:class="{
              disabled: currentPage <= 1
            }"
            :disabled="currentPage <= 1">
            <span aria-hidden="true" class="chevron left"></span>
            <span>前へ</span>
          </button>
          <button type="button" aria-controls="vgt-table"
            class="footer__navigation__page-btn" @click="pagination('next')"
            v-bind:class="{
              disabled: currentPage >= maxPage
            }"
            :disabled="currentPage >= maxPage">
            <span>次へ</span>
            <span aria-hidden="true" class="chevron right"></span>
          </button>
        </div>
      </div>
      <vue-good-table
        :columns='columns'
        :rows='rows'
        :isLoading.sync="lodingFlg"
        :group-options="{
          enabled: false
        }"
        @on-sort-change="onSortChange"
        v-if="!getLodingFlg && !getErrorFlg"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'path'" style="display: flex;">
            <div class="registered" v-if="props.formattedRow.method==='GET'" style="background-color: #2eb1e6">
                {{props.formattedRow.method}}
            </div>
            <div class="registered" v-else-if="props.formattedRow.method==='POST'">
                {{props.formattedRow.method}}
            </div>
            <div class="registered" v-else-if="props.formattedRow.method==='PUT'" style="background-color: #f2c501">
                {{props.formattedRow.method}}
            </div>
            <div class="registered" v-else-if="props.formattedRow.method==='PATCH'" style="background-color: #f2c501">
                {{props.formattedRow.method}}
            </div>
            <div class="registered" v-else-if="props.formattedRow.method==='DELETE'" style="background-color: #e94b35">
                {{props.formattedRow.method}}
            </div>
          </span>
          <span>{{props.formattedRow[props.column.field]}}</span>
          <span v-if="props.column.field === 'userId'" style="display: flex;">
            <div class="appendId" v-if="props.formattedRow.userName">{{props.formattedRow.userName}}</div>
          </span>
        </template>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>

      <!-- ローディング -->
      <div v-if="csvGetLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div style="padding: 0px 0px 30px 0px;">データの取得には時間を要する場合がございます。</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="csvGetErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{csvGetErrorMessage}}
          </div>
        </div>
      </div>

      <button type="button" class="csvBtn" @click="callOutputCsv()"
        :disabled="!csvDlFlg && !csvGetLodingFlg || maxCount > csvLimit"
        v-bind:class="{ disabled: !csvDlFlg || maxCount > csvLimit, active: csvDlFlg && maxCount <= csvLimit}">
        表示中のデータをCSV形式でダウンロード
      </button>
      <div　style="text-align:right">
        ※CSVダウンロード件数は最大{{csvLimit}}件になります。<br>
        　件数を超えている場合は検索条件にて絞り込みを行ってください。
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import '../style/vue-good-table.scss';
import { VueGoodTable } from 'vue-good-table';
import ApiClient from '../services/ApiClient';
import common from '../services/common';
import moment from 'moment';
import VCalendar from 'v-calendar';
import { VueLoading } from 'vue-loading-template';

export default {
  title: 'アクセスログ',
  name: 'accessLog',
  components: {
    VueGoodTable,
    VueLoading,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      // 検索項目用
      userIdOptions: [],
      userIdCondition: [],
      pathOptions: [],
      pathCondition: [],
      methodOptions: this.setMethodDropDown(),
      methodCondition: [],
      ipOptions: [],
      ipCondition: [],
      searchCondition: {},
      sortCondition: {},

      columns: [
        {
          label: '内部ID',
          field: 'id',
          hidden: true,
        },
        {
          label: 'ユーザーID',
          field: 'userId',
          sortable: true,
          width: '200px',
        },
        {
          label: 'ユーザー',
          field: 'userName',
          hidden: true,
        },
        {
          label: 'リクエストパス',
          field: 'path',
          sortable: true,
          width: '130px',
        },
        {
          label: 'リクエスト種別',
          field: 'method',
          sortable: true,
          hidden: true,
        },
        {
          label: 'IPアドレス',
          field: 'ip',
          width: '120px',
          sortable: true,
          formatFn: common.ipAddressFormat,
        },
        {
          label: '日時',
          field: 'dateTime',
          sortable: true,
          formatFn: this.callDateTimeFormat,
          width: '170px',
        },
        {
          label: 'ユーザーエージェント',
          field: 'ua',
          sortable: true,
          width: '500px',
        },
      ],
      rows: [],
      selectRow: {},
      // データ取得時ローディングフラグ
      getLodingFlg: false,
      // データ取得時エラーフラグ
      getErrorFlg: false,
      // CSVダウンロード可否フラグ
      csvDlFlg: false,
      // CSVダウンロード処理実行中フラグ
      csvGetLodingFlg: false,
      // CSVダウンロードエラーフラグ
      csvGetErrorFlg: false,
      // CSVダウンロードエラーメッセージ
      csvGetErrorMessage: false,
      // CSV取得上限
      csvLimit: 5000,
      // 検索上限
      limit: 100,
      // 検索内容最大件数
      maxCount: 0,
      // 現在ページ
      currentPage: 1,
      // 現在ページ
      inputPage: 1,
      // 最大ページ数
      maxPage: 1,
      // ソートローディングフラグ
      lodingFlg: false,
      // searchRange: {
      //   start: moment().add(0, 'months').startOf('month').format('YYYY-MM'),
      //   end: moment().add(0, 'months').endOf('month').format('YYYY-MM-DD'),
      // },
    };
  },
  // 初期処理
  async mounted() {
    try {
      // 初期検索のユーザID
      this.addUserIdTag(this.id);
      common.setUrlParam('userId', this.userIdCondition, 0);
      // URL検索条件確認
      this.userIdCondition = common.getUrlParam('userId', 0);
      this.methodCondition = common.getUrlParam('method', 0);
      this.pathCondition = common.getUrlParam('path', 0);
      this.ipCondition = common.getUrlParam('ip', 0);
      // 検索処理呼出
      await this.search();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
    getPaginateCount () {
      return Math.ceil(this.maxCount / this.limit);
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // アクセスログ一覧取得API呼び出し
    async callGetAccessLogs() {
      try {
        const restResourceService = new ApiClient();
        // アクセスログ一覧取得API
        const result = await restResourceService.getAccessLogs(
          this.limit,
          this.currentPage,
          this.searchCondition,
          this.sortCondition
        );
        // dateTime列用に登録日のデータを格納
        for (const accessLog of result.accessLogs) {
          accessLog.dateTime = accessLog.createdAt;
        }
        this.rows = result.accessLogs;
        this.maxCount = result.maxCount;
        this.maxPage = Math.ceil(this.maxCount / this.limit);
        // 初期テーブルデータをセット
        this.csvDlFlg  = (this.rows.length > 0) ? true : false;
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // リクエスト種別ドロップダウン
    setMethodDropDown() {
      const TAG_CODE = 'TAGCODE';
      return [
        'GET',
        'POST',
        'PUT',
        'PATCH',
        'DELETE',
      ];
    },
    // ユーザーID検索用タグ追加処理
    addUserIdTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };
      this.userIdCondition.push(tag);
      this.userIdOptions.push(tag);
    },
    // リクエストパス検索用タグ追加処理
    addPathTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };

      this.pathCondition.push(tag);
      this.pathOptions.push(tag);
    },
    // IPアドレス検索用タグ追加処理
    addIpTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };

      this.ipCondition.push(tag);
      this.ipOptions.push(tag);
    },
    // 検索
    async search() {
      // 一覧取得用の検索条件を詰める
      this.setCondition();
      // 検索条件をURLに詰める
      common.setUrlParam('userId', this.userIdCondition, 0);
      common.setUrlParam('method', this.methodCondition, 0);
      common.setUrlParam('path', this.pathCondition, 0);
      common.setUrlParam('ip', this.ipCondition, 0);
      try {
        // ローディング表示
        this.getLodingFlg = true;
        this.currentPage = 1;
        this.inputPage = this.currentPage;
        // アクセスログ一覧取得API呼出
        await this.callGetAccessLogs();
      } catch (error) {
        throw error;
      } finally {
        // ローディング非表示
        this.getLodingFlg = false;
      }
    },
    // 一覧上部の検索条件を詰める
    setCondition() {
      this.rows = [];
      this.searchCondition = {};
      if (this.userIdCondition.length === 0 && this.pathCondition.length === 0 &&
          this.methodCondition.length === 0 && this.ipCondition.length === 0) {
        return;
      }

      // 検索条件：ユーザID(部分一致)
      if (this.userIdCondition.length !== 0) {
        this.searchCondition.userId = [];
        for (const userId of this.userIdCondition) {
          this.searchCondition.userId.push(userId.name);
        }
      }

      // 検索条件：リクエスト種別（選択）
      if (this.methodCondition.length !== 0) {
        this.searchCondition.method = this.methodCondition;
      }

      // 検索条件：リクエストパス(部分一致)
      if (this.pathCondition.length !== 0) {
        this.searchCondition.path = [];
        for (const path of this.pathCondition) {
          this.searchCondition.path.push(path.name);
        }
      }

      // 検索条件：IPアドレス(部分一致)
      if (this.ipCondition.length !== 0) {
        this.searchCondition.ip = [];
        for (const ip of this.ipCondition) {
          this.searchCondition.ip.push(ip.name);
        }
      }
    },
    // 日時値を日時（YYYY年MM月DD日）に変換
    callDateTimeFormat(value) {
      return common.dateTimeFormatLog(value);
    },
    // CSV出力用共通関数呼出
    async callOutputCsv() {
      try {
        this.csvGetLodingFlg = true;
        window.addEventListener('beforeunload', common.confirmSave);
        // ローディングアニメ表示のために画面最下部を表示
        await this.$nextTick();
        await common.scrollBottom();
        // CSV取得処理（検索条件, ファイル名）
        await this.getCsv(
          this.csvLimit,
          this.searchCondition,
          this.sortCondition,
          'アクセスログ一覧'
        );
      } catch (error) {
        this.csvGetErrorMessage = error.message;
        this.csvGetErrorFlg = true;
      } finally {
        window.removeEventListener('beforeunload', common.confirmSave);
        this.csvGetLodingFlg = false;
      }
    },
    // ソート検索実行
    async onSortChange(params) {
      try {
        // ローディング表示
        this.lodingFlg = true;
        if (params[0].type !== 'none') {
          this.sortCondition = params[0];
        } else {
          this.sortCondition = {};
        }
        // アクセスログ一覧取得API呼出
        await this.callGetAccessLogs();
      } catch (error) {
        throw error;
      } finally {
        // ローディング非表示
        this.lodingFlg = false;
      }
    },
    // ページング処理
    async pagination(moveType) {
      try {
        // ローディング表示
        this.lodingFlg = true;
        if (moveType === 'next' && this.currentPage <= this.maxPage) {
          this.currentPage ++;
          this.inputPage = this.currentPage;
        } else if (moveType === 'back' && this.currentPage >= 1) {
          this.currentPage --;
          this.inputPage = this.currentPage;
        } else {
          return;
        }
        common.scrollTop();
        // アクセスログ一覧取得API呼出
        await this.callGetAccessLogs();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      } finally {
        // ローディング非表示
        this.lodingFlg = false;
      }
    },
    // ページング番号指定
    async paginationInput() {
      try {
        // ローディング表示
        this.lodingFlg = true;
        if (this.inputPage > this.maxPage || this.inputPage < 1) {
          this.inputPage = this.currentPage;
          return;
        }
        this.currentPage = this.inputPage;
        common.scrollTop();
        await this.callGetAccessLogs();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      } finally {
        // ローディング非表示
        this.lodingFlg = false;
      }
    },
    // ページングフォーカス外し時処理
    paginationBlue() {
      this.inputPage = this.currentPage;
    },

    // CSV出力用共通関数呼出
    // （検索条件,
    async getCsv(limit, searchCondition, sortCondition, pageName) {
      try {
        const restResourceService = new ApiClient();
        const result =  await restResourceService.getAccessLogsCsv(
          limit, searchCondition, sortCondition
        );
        // dateTime列用に登録日のデータを格納
        for (const accessLog of result) {
          accessLog.dateTime = this.callDateTimeFormat(accessLog.createdAt);
        }
        // ファイル名用の現在日時種痘
        const currentDate = new Date().getTime();
        const date = common.getToday(currentDate);
        const columns = this.columns;
        const rows = result;
        const fileName = pageName + date;
        common.outputCsv(columns, rows, fileName);
      } catch (error) {
        throw error;
      }
    },
    // 期間指定カレンダー変更時処理
    // picker(searchRange){
    //   this.rangeChange(true);
    //   common.setUrlParam('searchRangeStart', moment(searchRange.start).format('YYYY-MM-DD'), 2);
    //   common.setUrlParam('searchRangeEnd', moment(searchRange.end).format('YYYY-MM-DD'), 2);
    // },
    // 期間指定の選択範囲切り替え時に呼び出される
    // async rangeChange(getApiFlg) {
    //   const startEnd = {
    //     startOf: moment(this.searchRange.start).format('YYYY-MM-DD'),
    //     endOf: moment(this.searchRange.end).format('YYYY-MM-DD'),
    //   };
    //   if(getApiFlg) {
    //     const getStartEnd = {
    //       startOf: new Date(startEnd.startOf).getTime(),
    //       endOf: new Date(startEnd.endOf).getTime(),
    //     };
    //     // await this.callGetEntrances(getStartEnd);
    //   }
    // },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
